<template>
  <div>
    <vSelect
      :options="organisationOptions"
      v-model="organisation"
      :reduce="(label) => label.code"
      label="label"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import timetable from '@/store/timetable/timetable'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'OrganisationSelect',
  components: {
    vSelect,
  },
  data() {
    return {
      organisation2: this.id,
    }
  },
  props: {
    value: String,
    disabled: { type: Boolean, default: false },
  },
  computed: {
    organisationOptions: function () {
      const ret = []
      for (const a of this.$store.state.timetable.organisations.list) {
        ret.push({ code: a.id, label: a.id + ' ' + a.name })
      }
      return ret
    },
    organisation: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  created() {
    if (!this.$store.state.timetable) {
      this.$store.registerModule('timetable', timetable)
    }
  },
  mounted() {
    this.$store.dispatch('timetable/getOrganisationList')
  },
}
</script>